import { useFormik } from "formik";
import * as Yup from "yup";
import AlertErrorForm from "../../component/AlertErrorForm";
import { Modal } from "react-bootstrap";
import { URL_LIST_ALL } from "../../configs/api";
import Axios from "axios";
import { useState, useEffect } from "react";
import { confirmAlert } from "react-confirm-alert";
import { checkRole } from "../../model";

export default function ModalNote({
    showFullPhones,
    setShowFullPhones,
    item,
    user,
    pipelines,
    onClose,
}) {


    const [showModal, setShowModal] = useState(false);
    const [showModalInfo, setShowModalInfo] = useState(false);
    const role_transactions = checkRole(user, 'giao-dich', '');
    const [detail, setDetail] = useState(null);

    const formik = useFormik({
        initialValues: { user_id: user.data.id, customer_id: item && item.id, action: "note", mainnote: "" },
        enableReinitialize: true,
        validationSchema: Yup.object().shape({
            mainnote: Yup.string().trim().nullable().required('Nhập nội dung').max(150, "Độ dài không quá 150 ký tự"),
        }),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            setSubmitting(true)
            Axios.post(URL_LIST_ALL + 'sale_customer', values, user.config).then(res => {
                setSubmitting(false);
                setShowModal(!showModal)
                // setRefresh(!refresh)
                resetForm();
                onClose(); // đóng modal sau khi lưu
            }).catch(err => console.log(err));
        },
    });
    const formCustomer = useFormik({
        initialValues: detail && detail.id ? detail : item,
        enableReinitialize: true,
        validationSchema: Yup.object().shape({
            fullname: Yup.string().trim().nullable().required('Nhập họ tên').max(150, "Độ dài không quá 150 ký tự"),
            contact: Yup.string().trim().nullable().required('Nhập số điện thoại').max(150, "Độ dài không quá 150 ký tự"),
        }),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            Axios.put(URL_LIST_ALL + 'leads/' + item.id, values, user.config).then(res => {
                if (res.data.status == 'success') {
                    setSubmitting(false);
                    alert("Cập nhật thông tin khánh hàng thành công")
                }
            }).catch(err => console.log(err));
        },
    });

    const getPhoneDisplay = (item) => {
        if (item) {
            const phone = item.contact || "";
            const digits = phone.replace(/\D/g, "");
            if (showFullPhones == item.id) return digits;
            if (digits.length < 7) return digits;
            return `${digits.slice(0, 3)}****${digits.slice(-3)}`;
        } else {
            return null
        }
    };

    const mau_cautraloi = ["Không nghe máy", "Tắt máy luôn", "Kết bạn gửi Zalo", "Thuê bao", "Báo gọi lại sau"]

    const updateStatus = (status, title) => {
        setShowModal(!showModal)
        confirmAlert({
            title: "Thông báo",
            message: "Bạn có chắc chắn muốn chuyển sang " + title,
            buttons: [
                {
                    label: "Có",
                    onClick: () => {
                        Axios.post(URL_LIST_ALL + 'sale_customer', { user_id: user.data.id, customer_id: item.id, action: 'note', mainnote: "Chuyển sang <strong>" + title + "</strong>", status: 1 }, user.config).then(res => {
                        }).catch(err => console.log(err));
                        Axios.put(URL_LIST_ALL + 'leads/' + item.id, { position: status }, user.config).then(res => {
                        }).catch(err => console.log(err));

                    },
                },
                { label: "Không" },
            ],
        });
    }


    useEffect(
        function () {
            let mounted = true;
            if (showModal) {
                Axios.get(URL_LIST_ALL + "customers?lead_id=" + item.id, user.config)
                    .then(async (res) => {
                        if (res.data.status === "success") {
                            if (mounted && res.data.data.length > 0) {
                                let data = res.data.data
                                setDetail(data[0]);
                            }
                        } else console.log(res.data.message);
                    })
                    .catch((err) => console.log(err));
                return () => (mounted = false);
            }
        }, [user, showModal]
    );


    const updateInfo = () => {
        setShowModalInfo(!showModalInfo)
    }
    const ChuyenGiaoDich = () => {
        onClose()
        confirmAlert({
            title: "Chuyển sang trạng thái giao dịch thành công",
            message: "Hãy đảm bảo rằng bạn đã cập nhật đầy đủ thông tin của khách hàng !",
            buttons: [
                {
                    label: "Có",
                    onClick: () => {
                        Axios.post(URL_LIST_ALL + 'taogiaodich', { leads_id: item.id }, user.config).then(res => {
                            if (res.data.status == "success") {
                                alert("Chuyển thành công")
                            } else {
                                alert(res.data.message)
                            }
                        }).catch(err => console.log(err));
                    },
                },
                { label: "Không" },
            ],
        });

    }
    return (
        <>
            <Modal className="modal-sale-action"
                show={true}
                onHide={onClose}
                animation={true}
                size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Ghi chú khách hàng: {item && item.fullname} | <button type="button" className="btn btn-sm btn-info" onClick={() => {
                        setShowFullPhones(showFullPhones === item.id ? null : item.id);
                    }}>
                        <span>{getPhoneDisplay(item)}</span>
                    </button>

                        <button type="button" className="btn btn-sm btn-outline-success ml-2" onClick={() => updateInfo()}>
                            <span className="fas fa-plus"></span> Cập nhật thông tin
                        </button>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="new-added-form" method="post" onSubmit={formik.handleSubmit}>
                        <div className="row">
                            {checkRole(user, 'da-chot', 'action') && item.position != 9 &&
                                <>
                                    <div className="col-12">
                                        {mau_cautraloi.map((item) => {
                                            return <button type="button" className="btn btn-sm btn-secondary mr-2 mb-2" key={item}
                                                onClick={() => formik.setFieldValue('mainnote', item)}>{item}</button>
                                        })}
                                    </div>
                                    <div className="col-12">
                                        {pipelines && item.status == 1 &&
                                            pipelines.map((pipeline) => {
                                                if (item.position != pipeline.position && checkRole(user, pipeline.alias, "move")) {
                                                    return (
                                                        <button
                                                            key={pipeline.id}
                                                            type="button"
                                                            className={"btn btn-sm mr-2 mb-2 " + pipeline.alias}
                                                            onClick={() =>
                                                                updateStatus(pipeline.position, pipeline.title)
                                                            }
                                                            style={{
                                                                backgroundColor: pipeline.header_color
                                                                    ? pipeline.header_color
                                                                    : "transparent",
                                                                color: pipeline.text_color
                                                                    ? pipeline.text_color
                                                                    : "inherit",
                                                                border: "1px solid",
                                                            }}
                                                        >
                                                            {item.position <= pipeline.position
                                                                ? "Chuyển sang"
                                                                : "Chuyển về"}{" "}
                                                            "{pipeline.title}"
                                                        </button>
                                                    );
                                                } else {
                                                    return null;
                                                }
                                            })}
                                        {role_transactions && item.position < 9 &&
                                            <button type="button" className="btn btn-sm mr-2 mb-2" onClick={() => ChuyenGiaoDich()}>
                                                Chuyển sang giao dịch thành công
                                            </button>
                                        }

                                    </div>
                                </>
                            }


                            <div className="col-12 form-group mt-2">
                                <label>Nội dung ghi chú <span className="text-danger">*</span></label>
                                <textarea type="text" placeholder="Nhập nội dung" className="form-control" {...formik.getFieldProps("mainnote")} autoComplete="off"></textarea>
                                <AlertErrorForm formik={formik} name="mainnote"></AlertErrorForm>
                            </div>

                            <div className="col-12 form-group mg-t-8">
                                <button type="submit" disabled={formik.isSubmitting} className="btn btn-success">{formik.isSubmitting ? <div className="loader"></div> : <>Lưu lại</>}</button>
                                <button type="reset" onClick={formik.resetForm} className="btn btn-warning ml-2">Nhập lại</button>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>

            <Modal className="modal-sale-action" show={showModalInfo} onHide={() => setShowModalInfo(false)} animation={true} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Cập nhật thông tin khách hàng: {item && item.fullname}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="new-added-form" method="post" onSubmit={formCustomer.handleSubmit}>
                        <div className="row">
                            <div className="col-12 form-group mt-2">
                                <label>Họ và tên <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" {...formCustomer.getFieldProps("fullname")} />
                            </div>
                            <div className="col-12 col-sm-6 form-group ">
                                <label>Số điện thoại <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" {...formCustomer.getFieldProps("contact")} readOnly />
                            </div>
                            <div className="col-12 col-sm-6 form-group ">
                                <label>Email</label>
                                <input placeholder="VD: abc@domain.com" type="text" className="form-control" {...formCustomer.getFieldProps("email")} />
                            </div>
                            <div className="col-12 col-sm-6 form-group ">
                                <label>Địa chỉ</label>
                                <input placeholder="VD: Số 6 Lê Văn Thiêm,..." type="text" className="form-control" {...formCustomer.getFieldProps("address")} />
                            </div>
                            <div className="col-12 col-sm-6 form-group ">
                                <label>Số căn cước công dân</label>
                                <input placeholder="VD: 0023456777" type="text" className="form-control" {...formCustomer.getFieldProps("cccd_id")} />
                            </div>
                            <div className="col-12 col-sm-6 form-group ">
                                <label>Địa chỉ thường chú</label>
                                <input placeholder="VD: Số 6 Lê Văn Thiêm,..." type="text" className="form-control" {...formCustomer.getFieldProps("cccd_address")} />
                            </div>
                            <div className="col-12 col-sm-6 form-group ">
                                <label>Nơi cấp</label>
                                <input placeholder="VD: Cục Cảnh sát QLHC về TTXH" type="text" className="form-control" {...formCustomer.getFieldProps("cccd_noicap")} />
                            </div>
                            <div className="col-12 col-sm-6 form-group ">
                                <label>Ngày cấp</label>
                                <input placeholder="VD: 15-02-2025" type="date" className="form-control" {...formCustomer.getFieldProps("cccd_date")} />
                            </div>
                            <div className="col-12 col-sm-6 form-group ">
                                <label>Ngày sinh</label>
                                <input placeholder="VD: 15-02-2025" type="date" className="form-control" {...formCustomer.getFieldProps("birthday")} />
                            </div>
                            <hr />
                            <div className="col-12 form-group ">
                                <label>Nội dung ghi chú</label>
                                <textarea type="text" placeholder="Nhập nội dung" className="form-control" {...formCustomer.getFieldProps("note")} autoComplete="off"></textarea>
                            </div>

                            <div className="col-12 form-group mg-t-8">
                                <button type="submit" disabled={formCustomer.isSubmitting} className="btn btn-success">{formCustomer.isSubmitting ? <div className="loader"></div> : <>Lưu lại</>}</button>
                                <button type="reset" onClick={formCustomer.resetForm} className="btn btn-warning ml-2">Nhập lại</button>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
}
